module.exports = __webpack_public_path__ + "img/class-fast-banner-jp.159198d.png";